import * as React from 'react';
import { createPortal } from 'react-dom';
import { mergeStyles } from '@cian/utils/lib/shared/style';

import { CloseIcon } from '../../../../../components/close_icon';

const styles = require('./modal.css');

export interface IModalProps {
  modalClassName?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClose(): any;
  children: React.ReactNode;
}

export class Modal extends React.Component<IModalProps> {
  private container = (typeof window !== 'undefined' && window.document && window.document.body) || null;

  public render() {
    const { container } = this;

    if (!container) {
      return null;
    }

    return createPortal(this.renderModal(), container);
  }

  private renderModal() {
    return (
      <div className={styles['overlay']} onClick={this.handleOverlayClick}>
        <div {...mergeStyles(styles['modal'], this.props.modalClassName)}>
          {this.props.children}
          <CloseIcon className={styles['close']} onClick={this.handleClose} />
        </div>
      </div>
    );
  }

  private handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  private handleOverlayClick = (e: React.SyntheticEvent<HTMLElement>) => {
    if (e.currentTarget !== e.target) {
      return;
    }

    this.handleClose();
  };
}
